const homeCarouselStyle = {


};

export default homeCarouselStyle;
